export const APP_NAME = 'Open Deal';

export const APP_SCOPE = 'deal-mgmt.opendeal.app.access';
export const CLIENT_ID = '0oa155l2qf5vxAKpY358';
export const NON_PROD_CLIENT_ID = '0oa155l49vcZSyvqF358';

export const OKTA_CONFIG_ID_PROD = 'od_prod_bridge_signin_spa_makemydeal';
export const OKTA_CONFIG_ID_NON_PROD = 'od_nonprod_bridge_signin_spa_makemydeal';
